
// titles
export const GET_TITLES = "/api/v1/titles";
export const ADD_NEW_TITLE = "/api/v1/titles";
export const UPDATE_TITLE = "/api/v1/titles";
export const DELETE_TITLE = "/api/v1/titles";


